import React from 'react';

// Iconos del menu de usuario, inline en vez de los PNG de S3: se pintan con la
// pagina sin una peticion por icono, escalan sin pixelarse y el color lo decide
// la hoja de estilos en vez de venir quemado en el archivo.
//
// Estilo Fluent Color: rejilla de 24, formas geometricas de esquinas redondeadas
// y dos materiales con degradado. .icon-base es la pieza blanca que da la
// silueta; .icon-accent es el detalle en azul vivo. El degradado es lo que los
// saca de la lectura plana: una silueta de un solo tono sobre un fondo de un solo
// tono no tiene de donde sacar volumen.
//
// Los cuatro colores viven en header.scss como variables sobre el <header>, y
// IconDefs los lee desde ahi. Por eso los degradados se declaran una sola vez y
// dentro de la cabecera: una variable CSS se resuelve donde esta definido el
// degradado, no donde se usa, asi que sacarlos fuera los dejaria sin color.
export const IconDefs = () => (
	<svg className="icon-defs" width="0" height="0" aria-hidden="true" focusable="false">
		<defs>
			<linearGradient id="s7-ico-base" x1="0" y1="0" x2="0.65" y2="1">
				<stop offset="0" stopColor="var(--icon-base-1)"/>
				<stop offset="1" stopColor="var(--icon-base-2)"/>
			</linearGradient>

			<linearGradient id="s7-ico-accent" x1="0" y1="0" x2="0.7" y2="1">
				<stop offset="0" stopColor="var(--icon-accent-1)"/>
				<stop offset="1" stopColor="var(--icon-accent-2)"/>
			</linearGradient>
		</defs>
	</svg>
);

// aria-hidden porque cada icono va pegado a su texto: anunciarlo seria repetir
// la etiqueta que el lector de pantalla ya lee.
const Icon = ({children}) => (
	<svg className="menu-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
		{children}
	</svg>
);

// Carpeta abierta con un documento asomando: proyectos.
export const IconProjects = () => (
	<Icon>
		<path className="icon-accent" d="M2.6 6.4A2.5 2.5 0 0 1 5.1 3.9h3.5c.56 0 1.1.22 1.5.62l1.4 1.38h7A2.5 2.5 0 0 1 21 8.4v2.2H2.6V6.4z"/>
		<rect className="icon-base" x="7.1" y="7.3" width="9.8" height="5.4" rx="1.1"/>
		<path className="icon-base" d="M2.6 10.6h18.4v6.9a2.5 2.5 0 0 1-2.5 2.5H5.1a2.5 2.5 0 0 1-2.5-2.5v-6.9z"/>
	</Icon>
);

// Edificio con puerta y ventanas: los proveedores, que son companias.
export const IconProviders = () => (
	<Icon>
		<path className="icon-base" d="M5.3 2.4h6.4a2 2 0 0 1 2 2v17.2H3.3V4.4a2 2 0 0 1 2-2z"/>
		<path className="icon-base" d="M15.3 9.6h3.4a2 2 0 0 1 2 2v10h-5.4V9.6z"/>
		<rect className="icon-accent" x="5.6" y="5.3" width="2.5" height="2.5" rx=".75"/>
		<rect className="icon-accent" x="8.9" y="5.3" width="2.5" height="2.5" rx=".75"/>
		<rect className="icon-accent" x="5.6" y="9.4" width="2.5" height="2.5" rx=".75"/>
		<rect className="icon-accent" x="8.9" y="9.4" width="2.5" height="2.5" rx=".75"/>
		<rect className="icon-accent" x="16.3" y="12.6" width="2.3" height="2.3" rx=".7"/>
		<rect className="icon-accent" x="16.3" y="16.5" width="2.3" height="2.3" rx=".7"/>
		<path className="icon-accent" d="M6.7 21.6v-5.1a1.8 1.8 0 0 1 1.8-1.8 1.8 1.8 0 0 1 1.8 1.8v5.1H6.7z"/>
	</Icon>
);

// Ficha de contacto: una persona y sus datos, no dos siluetas sueltas.
export const IconContacts = () => (
	<Icon>
		<rect className="icon-base" x="2.3" y="4.4" width="19.4" height="15.2" rx="2.7"/>
		<circle className="icon-accent" cx="8.7" cy="10.3" r="2.5"/>
		<path className="icon-accent" d="M8.7 13.5c2.21 0 4 1.24 4 2.77v.35a.9.9 0 0 1-.9.9H5.6a.9.9 0 0 1-.9-.9v-.35c0-1.53 1.79-2.77 4-2.77z"/>
		<rect className="icon-accent" x="14.3" y="9.1" width="5.1" height="1.8" rx=".9"/>
		<rect className="icon-accent" x="14.3" y="12.5" width="5.1" height="1.8" rx=".9"/>
	</Icon>
);

// Esfera de reloj con anillo interior: el historial de envios.
export const IconHistory = () => (
	<Icon>
		<circle className="icon-base" cx="12" cy="12" r="9.2"/>
		<path className="icon-ring" d="M12 3.4a8.6 8.6 0 1 0 0 17.2 8.6 8.6 0 0 0 0-17.2zm0 1.7a6.9 6.9 0 1 1 0 13.8 6.9 6.9 0 0 1 0-13.8z"/>
		<path className="icon-accent" d="M12 6.5a1 1 0 0 1 1 1v4.07l2.87 1.66a1 1 0 1 1-1 1.73l-3.37-1.95a1 1 0 0 1-.5-.86V7.5a1 1 0 0 1 1-1z"/>
		<circle className="icon-accent" cx="12" cy="12" r="1.15"/>
	</Icon>
);

// Avatar: el perfil propio. La persona va dentro del disco, no suelta.
export const IconUser = () => (
	<Icon>
		<circle className="icon-base" cx="12" cy="12" r="9.3"/>
		<circle className="icon-accent" cx="12" cy="9.6" r="3.4"/>
		<path className="icon-accent" d="M12 14.1c3.18 0 5.83 1.76 6.38 4.08A9.26 9.26 0 0 1 12 21.3a9.26 9.26 0 0 1-6.38-3.12C6.17 15.86 8.82 14.1 12 14.1z"/>
	</Icon>
);

// Megafono con asa y ondas: los releases, que son los anuncios.
export const IconReleases = () => (
	<Icon>
		<path className="icon-accent" d="M6.6 16.6h2.7l1.05 3.4a1.5 1.5 0 0 1-2.87.88L6.6 16.6z"/>
		<path className="icon-base" d="M3.5 9.5a2.4 2.4 0 0 1 2.4-2.4h2.3l6.6-3.72A1.25 1.25 0 0 1 16.7 4.47v15.06a1.25 1.25 0 0 1-1.9 1.09L8.2 16.9H5.9a2.4 2.4 0 0 1-2.4-2.4V9.5z"/>
		<path className="icon-accent" d="M19.05 8.5a1.05 1.05 0 0 1 1.46.26 6.45 6.45 0 0 1 0 7.08 1.05 1.05 0 1 1-1.72-1.2 4.35 4.35 0 0 0 0-4.68 1.05 1.05 0 0 1 .26-1.46z"/>
	</Icon>
);

// Puerta en perspectiva con pomo y flecha saliendo: cerrar sesion.
export const IconLogout = () => (
	<Icon>
		<path className="icon-base" d="M3.4 5.1c0-1.18.86-2.19 2.03-2.36l4.6-.66A2.4 2.4 0 0 1 12.8 4.46v15.08a2.4 2.4 0 0 1-2.77 2.37l-4.6-.66A2.4 2.4 0 0 1 3.4 18.9V5.1z"/>
		<circle className="icon-accent" cx="10.2" cy="12" r="1.1"/>
		<path className="icon-accent" d="M16.6 7.5a1.05 1.05 0 0 1 1.49 0l3.6 3.6a1.05 1.05 0 0 1 0 1.49l-3.6 3.6a1.05 1.05 0 1 1-1.49-1.49l1.81-1.81h-3.26a1.05 1.05 0 0 1 0-2.1h3.26L16.6 8.99a1.05 1.05 0 0 1 0-1.49z"/>
	</Icon>
);

// Punto de estado junto al nombre de la compania. Se queda verde a proposito:
// aqui el color es el dato, no decoracion, y en azul dejaria de significar
// "conectado".
export const IconOnline = () => (
	<svg className="status-dot" viewBox="0 0 12 12" aria-hidden="true" focusable="false">
		<circle cx="6" cy="6" r="5"/>
	</svg>
);
